export default __webpack_public_path__ + "static/our-process-9d51b177fb52e7dbc3c3225326db3093.svg";